module.exports = __webpack_public_path__ + "static/media/sahyadri.db72ad8f.svg";